<template>
  <v-app id="app">
    <v-main
      fluid
    >
      <v-row
        v-show="showForm"
        id="auth"
        align-content="center"
        justify="center"
      >
          <v-card
            class="sign-in-form d-flex justify-center mx-1"
            width="380px"
            height="460px"
          >
            <v-card-title primary-title>
              <div class="form-headline mx-6 py-2">
                <p class="mx-12">
                  <logo-vue :white="true"></logo-vue>
                </p>
                <p class="text-center heading-6" id="title">Авторизация</p>
              </div>
              <Note v-if="showNote"></Note>
              <AuthForm
                :redirectPath = "redirectPath"
                @loginDisabled="disableLogin()"
              ></AuthForm>
            </v-card-title>
          </v-card>
          <!-- <v-card
            class="mx-1 py"
            width="380px"
            height="460px"
          >
            <v-card-text class="mt-6">
              <p class="text-caption mx-6">Мы на связи <a class="text-decoration-none font-weight-bold" :href="'tel:' + phone">{{ phone }}</a></p>
            </v-card-text>
          </v-card> -->
      </v-row>
      <v-row
          v-if="!showForm"
          id="progress"
          class="justify-center align-center"
      >
        <v-progress-circular indeterminate size="80" color="warning"/>
      </v-row>
    </v-main>
    <Snack/>
  </v-app>
</template>

<script>
import Snack from '../Snack'
import logoVue from './../logo'
import Note from './Note'
import AuthForm from './Form'

export default {
  name: "SignIn",
  components: {
    Snack,
    logoVue,
    Note,
    AuthForm
  },
  data() {
    return {
      loginDisabled: false,
      showForm: false,
      showNote: false,
      redirectPath: '',
      phone: '+78127045576'
    }
  },
  beforeMount() {
    if (localStorage.getItem('so_token')) {
      this.checkAuth()
    } else this.showForm = true
  },
  computed: {
    token() { return this.$store.getters['common/getTokenForOld'] },
    disabledBtn() { return this.authData.username.length < 2 }
  },
  methods: {
    async checkAuth() {
      const res = await this.$store.dispatch('common/getUserDetails')
      if (!res) {
        localStorage.removeItem('so_token')
        this.showForm = true
      } else {
        this.redirectPath = localStorage.getItem('so_token')
      }
    },
    disableLogin() {
      this.loginDisabled = true
    }
  },
  watch: {
    '$v.$invalid' (val) {
      this.loginDisabled = val
    },
  }
}
</script>

<style lang="scss" scoped>
#app {
  background-color: #F2F4FD;
}
#auth {
  height: 100vh;
  background-image: url(https://sakura-aero.com/wp-content/themes/sacura/assets/img/opening-sakura.png);
  background-position: center center
}
#progress {
  height: 100vh
}
#logo img {
  background-color: #3D4376;
}
#title {
  color: #FFFFFF;
}
.sign-in-form{
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding-top: 28px;
}
.form-headline{
  width: 100%;
  border-radius: 10px;
  background-color: #3D4376;
}
</style>